export default __webpack_public_path__ + "static/rsa_lotto_plus_1-dd3695ad20d9e3645c4e657e88b76dba.png";